var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScoresBannerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 102,
    viewBox: "0 0 97 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.2546 59.2051V67.342C69.2546 74.2034 62.6869 79.7673 54.5844 79.7673C46.482 79.7673 39.9143 74.2034 39.9143 67.342V59.2051C39.9143 66.0665 46.482 70.9706 54.5844 70.9706C62.6869 70.9706 69.2546 66.0665 69.2546 59.2051Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2546 67.9238V76.0607C69.2546 82.9221 62.6869 88.486 54.5844 88.486C46.482 88.486 39.9143 82.9221 39.9143 76.0607V67.9238C39.9143 74.7852 46.482 79.6894 54.5844 79.6894C62.6869 79.6894 69.2546 74.7852 69.2546 67.9238Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2531 48.2085V59.2043C69.2531 66.0657 62.6854 70.9699 54.583 70.9699C46.4806 70.9699 39.9128 66.0657 39.9128 59.2043V48.2085C39.9128 41.3471 46.4806 35.7832 54.583 35.7832C58.6455 35.7832 62.3017 37.1687 64.9649 39.4118C67.6056 41.677 69.2531 44.7778 69.2531 48.2085Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2531 48.2085C69.2531 50.2097 68.6889 52.057 67.6958 53.6404C65.2809 57.511 60.3156 59.974 54.583 59.974C48.8503 59.974 43.8851 57.511 41.4701 53.6404C40.4771 52.057 39.9128 50.2097 39.9128 48.2085C39.9128 44.7778 41.5604 41.677 44.201 39.4338C46.8642 37.1687 50.5205 35.7832 54.583 35.7832C58.6455 35.7832 62.3017 37.1687 64.9649 39.4118C67.6056 41.677 69.2531 44.7778 69.2531 48.2085Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3036 89.7631C66.2127 90.725 68.44 91.2716 70.8528 91.2716L74.8956 91.2716L75.9373 62.8518C75.9373 62.8518 74.9892 62.8516 70.8528 62.8516C68.44 62.8516 66.2127 63.3981 64.3036 64.36C59.6369 66.6992 56.6672 71.5087 56.6672 77.0616C56.6672 82.6144 59.6369 87.4239 64.3036 89.7631Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0187 91.2716C72.6058 91.2716 70.3785 90.725 68.4695 89.7631C63.8028 87.4239 60.8331 82.6144 60.8331 77.0616C60.8331 71.5087 63.8028 66.6992 68.4695 64.36C70.3785 63.3981 72.6058 62.8516 75.0187 62.8516C79.1551 62.8516 82.8937 64.4474 85.5982 67.0052C88.3293 69.5849 89.9998 73.1265 89.9998 77.0616C89.9998 80.9966 88.3293 84.5382 85.6248 87.1179C82.8937 89.6757 79.1551 91.2716 75.0187 91.2716Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.802 55.6405L16.0018 54.7071C15.62 54.5798 15.026 54.6647 14.7008 54.9051L12.7279 56.3123C11.4622 57.2103 10.4299 56.687 10.4299 55.1314L10.4298 52.5009C10.4298 52.0625 10.1258 51.5039 9.74396 51.2635L7.73576 50.0049C6.15184 49.0149 6.33569 47.827 8.14588 47.3603L10.6703 46.7168C11.1299 46.5966 11.5966 46.1299 11.7168 45.6703L12.3603 43.1459C12.8269 41.3357 14.0149 41.1519 15.0048 42.7358L16.2635 44.744C16.4968 45.1188 17.0554 45.4228 17.5009 45.4299L20.1313 45.4299C21.687 45.4299 22.2173 46.4693 21.3122 47.728L19.9051 49.7008C19.6717 50.0331 19.5798 50.62 19.7071 51.0019L20.6405 53.802C21.1496 55.3152 20.3152 56.1496 18.802 55.6405Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3347 49.8491L28.2844 54.7988",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8493 58.3354L19.7991 63.2852",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6275 57.6268L24.0417 59.041",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4464 23.2486L72.6005 19.7862C72.7579 19.3141 72.653 18.5796 72.3557 18.1774L70.6157 15.738C69.5053 14.1729 70.1524 12.8964 72.0759 12.8964L75.3285 12.8963C75.8706 12.8963 76.5613 12.5204 76.8586 12.0482L78.4149 9.56506C79.639 7.60652 81.1079 7.83385 81.685 10.0722L82.4807 13.1936C82.6293 13.762 83.2064 14.339 83.7747 14.4876L86.8961 15.2833C89.1345 15.8604 89.3618 17.3293 87.4033 18.5534L84.9201 20.1097C84.4567 20.3982 84.0807 21.089 84.072 21.6398L84.072 24.8924C84.072 26.816 82.7867 27.4718 81.2303 26.3526L78.7909 24.6126C78.38 24.3241 77.6543 24.2104 77.1821 24.3678L73.7197 25.5219C71.8486 26.1515 70.8169 25.1198 71.4464 23.2486Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6075 28.8542L72.4871 34.9746",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1141 18.362L61.9937 24.4824",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9902 27.9798L67.2415 29.7285",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoresBannerIcon);
export default __webpack_public_path__ + "static/media/scores_banner_icon.c9476e0e00bb4dc502e1b814e9bc5eeb.svg";
export { ForwardRef as ReactComponent };